export function getFilteredHeaders(response: Response): { responseHeaders: Record<string, string> } {
	const headers = new Map(response.headers?.entries() || []);
	headers.delete('cookie');
	return { responseHeaders: Object.fromEntries(headers) };
}
